module.exports = __webpack_public_path__ + "static/94aa0d4d07ee61895c492d1cd3044991a9205e9be013b9b51c704c1f244fdc61-1f406b65b203065a097359a64972c4d2.jpeg";